import React, { ReactNode } from "react";

interface CardType {
  children: ReactNode;
  style?: React.CSSProperties;
  className?: string;
}
const Card = ({ className, children, style }: CardType): JSX.Element => {
  return (
    <div className={[className, "aup-card"].join(" ")} style={style}>
      {children}
    </div>
  );
};

export default Card;
